import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../assets/styles/MainSlider.css"; // Custom styles
import { Link } from "react-router-dom";

const MainSlider = ({data}) => {

  return (
    <div className="main-slider">
      <Swiper
        modules={[Autoplay, Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        speed={1000}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        className="fullscreen-swiper"
      >
        {data.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div
              className="slide-content"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="slide-overlay">
                <div className="slide-text px-4 xl:px-0 font-mono">
                  <h1>{slide.title}</h1>
                  <p>{slide.subtitle}</p>
                  <Link to={slide.link}>
                    <button className="cta-button">{slide.linkTitle}</button>
                  </Link>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MainSlider;
